<template>
  <div>
    <el-dialog
      title="发起退款"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="900px"
      v-dialogDrag
      @close="close"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="订单编号" prop="orderId" v-if="orderID == ''">
          <el-input
            class="input-width"
            v-model="dataObj.orderId"
            placeholder="请输入"
            @blur="getPlatfromId"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款原因" prop="refundReason">
          <div style="display: flex">
            <el-select
              v-model="classAtxt"
              clearable
              placeholder="请选择"
              class="input-width"
              style="margin-right: 10px"
              @change="setReason"
            >
              <el-option
                v-for="(val, key, i) in classA.primaryReason"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
            <el-select
              v-model="dataObj.refundReason"
              placeholder="请先选择一级原因"
              class="input-width"
              @change="getRefundReason"
            >
              <el-option
                v-for="(val, i) in secondLevel"
                :label="val"
                :value="i"
                :key="i"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="是否全款" prop="isFull">
          <el-radio-group v-model="dataObj.isFull">
            <el-radio label="1">全额退款</el-radio>
            <el-radio label="2">部分退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isRefund" label="是否已退款"></el-checkbox>
        </el-form-item>
        <el-form-item label="退款说明" prop="refundExplain">
          <el-input
            style="width: 380px"
            type="textarea"
            :rows="4"
            v-model="dataObj.refundExplain"
            placeholder="请输入"
            :maxlength="maxlength"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">退款明细</el-divider>
        <el-table
          :data="dataTable"
          border
          :header-cell-style="{ background: '#F8F8F8' }"
          show-summary
          :summary-method="getGroupSummaries"
          v-loading="loading"
          :span-method="objectSpanMethod"
        >
          <el-table-column label="SKU信息" align="center">
            <template slot-scope="scope">
              <div style="display: flex">
                <el-image
                  style="width: 100px"
                  :src="scope.row.firstImg"
                ></el-image>
                <div style="text-align: left; margin-left: 5px">
                  <p>SKU：{{ scope.row.sku }}</p>
                  <p>产品名称：{{ scope.row.skuName }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="订单金额（本币）"
            width="180px"
            align="center"
            prop="productTotalPrice"
          >
            <template>
              {{ orderAmount + " (" + dataObj.orderCurrency + ")" }}
            </template>
          </el-table-column>
          <el-table-column
            label="产品价格"
            width="120px"
            align="center"
            prop="productTotalPrice"
          >
            <template slot-scope="scope">
              {{
                scope.row.productTotalPrice != "" &&
                dataObj.orderCurrency !== ""
                  ? scope.row.productTotalPrice +
                    "(" +
                    dataObj.orderCurrency +
                    ")"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="已退金额"
            width="120px"
            align="center"
            prop="refundPrice"
          >
            <template slot-scope="scope">
              {{
                scope.row.refundPrice && dataObj.orderCurrency
                  ? scope.row.refundPrice + " (" + dataObj.orderCurrency + ")"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="退款"
            width="130px"
            align="center"
            v-if="dataObj.isFull == 2"
          >
            <template slot-scope="scope">
              <el-form-item label-width="0px">
                <el-input
                  v-model="scope.row.refundAmount"
                  @blur="count(scope.$index, scope.row)"
                  autocomplete="off"
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" v-preventReClick="5000" :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 发起退款弹窗
 * 功能：输入订单号拉取 SKU 明细，选择一二级退款原因/是否全款/部分退款金额，支持合计与行合并，提交退款申请。
 * 备注：潜在问题——无论 platform=1 或 2，提交均调用 amazonApplyRefund（eBayRefund 页也复用此组件，疑似 API 复用错误，需后端确认是否兼容）。
 */
import {
  getSkuInfoById,
  getBaseRefundReason,
  amazonApplyRefund,
} from "@/api/user";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    platform: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    orderID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      radio: "",
      // 按钮禁用状态（定义了未用）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 退款明细加载状态
      loading: false,
      orderAmount: "", // 订单金额
      // 是否已退款标识
      isRefund: "",
      // 退款申请提交数据
      dataObj: {
        orderId: "",
        refundReason: "",
        isFull: "",
        refundExplain: "",
        account: "",
        platformId: "",
        platform: 1,
        isRefund: "",
        refundItemDetailList: [],
      },
      rules: {
        orderId: [{ required: true, message: "请输入订单号", trigger: "blur" }],
        refundReason: [
          { required: true, message: "请选择退款原因", trigger: "blur" },
        ],
        isFull: [
          { required: true, message: "请选择是否全款", trigger: "blur" },
        ],
      },
      // 退款明细表格数据（SKU 行）
      dataTable: [],
      // 一级退款原因 key
      classAtxt: "",
      secondTxt: "",
      classA: {}, // 一级原因
      secondLevel: {}, // 二级原因
    };
  },
  computed: {
    /** 退款说明最大长度（Amazon 500 字，eBay 100 字） */
    maxlength() {
      if (this.platform === 1) {
        return 500;
      } else {
        return 100;
      }
    },
  },
  /** 加载退款原因字典；若由邮件详情跳转带入订单号则直接拉取明细 */
  created() {
    this.getReason();
    if (this.orderID !== "") {
      // 从邮件详情获取的订单号
      this.loading = true;
      this.dataObj.orderId = this.orderID;
      this.init(this.orderID);
    }
  },
  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /** 订单号输入框失焦时按订单号拉取退款明细 */
    getPlatfromId() {
      if (this.dataObj.orderId !== "") {
        this.loading = true;
        this.init(this.dataObj.orderId);
      }
    },
    /** 按订单号查询 SKU 明细并回填订单信息
     * @param {String} orderId 订单编号
     */
    init(orderId) {
      getSkuInfoById({ orderId: orderId }).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          Object.assign(this.dataObj, res.data);
          this.orderAmount = res.data.orderAmount;
          this.dataTable = [];
          res.data.skuInfos.forEach((item) => {
            this.dataTable.push({
              refundAmount: 0,
              firstImg: item.firstImg,
              lineItemId: item.lineItemId,
              lineItemId2: item.lineItemId2,
              productTotalPrice: item.productTotalPrice,
              refundPrice: item.refundPrice,
              sku: item.sku,
              skuName: item.skuName,
            });
          });
          this.dataObj.account = res.data.accountNumber;
          this.dataObj.platformId = res.data.platformOrderId;
          this.dataObj.currency = res.data.orderCurrency;
          this.$delete(this.dataObj, "skuInfos");
        } else {
          this.loading = false;
        }
      });
    },
    /** 拉取退款原因字典（一二级原因） */
    getReason() {
      getBaseRefundReason().then((res) => {
        if (res.code === 200) {
          this.classA = res.data;
        }
      });
    },
    /** 选择一级退款原因时联动加载对应的二级原因
     * @param {String} val 一级原因 key
     */
    setReason(val) {
      if (val === "") {
        this.dataObj.refundReason = "";
        this.secondTxt = "";
      }
      this.secondLevel = this.classA.secondaryReason[val];
    },
    /** 选择二级退款原因时回写提交数据
     * @param {*} val 二级原因 value
     */
    getRefundReason(val) {
      this.dataObj.refundReason = val;
    },
    /** 部分退款金额输入校验（注意：amount 为 parseInt 结果，NaN 恒不等于 ""，空值/合法性校验实际失效） */
    count(index, row) {
      const amount = parseInt(row.refundAmount);
      const reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (amount !== "") {
        if (!reg.test(amount)) {
          this.$message.error("请输入正确金额,最多保留两位小数！");
          return (this.dataTable[index].refundAmount = 0);
        }
        // if (
        //   amount < 0 ||
        //   amount > parseInt(row.productTotalPrice - row.refundPrice).toFixed(2)
        // ) {
        //   this.$message.error("退款金额不能大于产品价格减已退金额！");
        //   return (this.dataTable[index].refundAmount = "");
        // }
      }
    },
    /** 按是否全款组装退款明细提交数据（部分退款分支逻辑已被注释；全额退款时不传 refundAmount）
     * @param {Number} val 1 全额退款；2 部分退款
     */
    getIsFull(val) {
      this.dataObj.refundItemDetailList = JSON.parse(
        JSON.stringify(this.dataTable)
      );
      if (val == 2) {
        // this.dataTable.forEach((item) => {
        //   item.refundAmount = 0;
        // });
        // this.dataObj.refundItemDetailList = this.dataTable;
      }
      if (val == 1) {
        // 全额退款不传refundAmount
        this.dataObj.refundItemDetailList.forEach((item) => {
          this.$delete(item, "refundAmount");
        });
      }
    },
    /** 退款明细表格合计行计算（订单金额列显示订单总额，其余数值列求和）
     * @param {Object} param 表格合计回调参数（columns 列配置、data 行数据）
     * @returns {Array} 合计行各列文案
     */
    getGroupSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        // 订单金额
        if (index === 1) {
          sums[index] =
            this.orderAmount + "(" + this.dataObj.orderCurrency + ")";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          const num = sums[index].toFixed(2);
          sums[index] = num + "(" + this.dataObj.orderCurrency + ")";
        } else {
          sums[index] = "——";
        }
      });
      return sums;
    },
    /** 校验表单并提交退款申请，成功后关闭弹窗并刷新列表
     * @param {String} formName 表单 ref 名称
     */
    checkAdd(formName) {
      this.dataObj.platform = this.platform;
      // this.$delete(this.dataObj, "orderAmount");
      this.getIsFull(this.dataObj.isFull);
      if (this.dataTable.length <= 0) {
        this.$message.error("获取退款明细失败！不能发起退款！");
        return false;
      }
      // 是否已退款
      this.dataObj.isRefund = this.isRefund ? 1 : 2;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          amazonApplyRefund(this.dataObj).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.$emit("isShowEdit");
              this.$emit("getList");
            }
          });
        } else {
          return false;
        }
      });
    },
    /** 订单金额列行合并（硬编码第一行 rowspan=6，行数变化时需同步调整） */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: 6,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>
<style lang="scss">
.el-table__footer-wrapper {
  font-weight: bold;
  font-size: 14px;
}
</style>